import React from 'react'
import { Image, Tools, View } from '@/lib'
import { Theme } from '@/app'
import { DemoDevice, GeneralCardProps, Reveal } from '@/components'
import { Assets } from '@/assets'
import { apps } from '../data'
import CardComponents from './components'

const AWSGirlsTechSeriesCard = (props: GeneralCardProps) => {

  const {
    onSelect,
    position = 'right',
  } = props

  const { height } = Theme.hooks.size()

  const isLargeish = Theme.hooks.down('largeish')
  const upLarge = Theme.hooks.up('large')

  const isMobile = Theme.hooks.down('mid')
  const limitedPerformance = Tools.useLimitedPerformance()

  const data = apps['aws-girls-tech-series-web']

  return (
    <CardComponents.AppRow
      elemName={'aws-girls-tech-series'}
      background={data.background}
      position={position}
    >
      <View style={styles.wrapper}>
        <CardComponents.AppDescription data={data} position={position}/>
        {isLargeish ? (
          <DemoDevice.DemoRow data={data} onSelect={onSelect}/>
        ) : (
          <View style={styles.imagesWrapper}>
            <View style={styles.tabletWrapper}>
              <Reveal
                variant={'parallaxBackground'}
                amount={'10vh'}
                offset={height * -(upLarge ? 0.3 : 0.05)}
                duration={height * 1.1}
                stopProgressAt={upLarge ? 0.55 : 0.3}
                disabled={isMobile || limitedPerformance > 0}
              >
                <div className={'willChangeTransform'}>
                  <View style={styles.tabletInnerWrapper}>
                    <Image
                      loading={'eager'}
                      src={Assets.Portfolio.AWSGirlsTechSeries[upLarge ? 'background-tablet-1' : 'mockup']}
                      style={styles.image}
                    />
                  </View>
                </div>
              </Reveal>
            </View>
            {upLarge ? (
              <Reveal
                variant={'parallaxReverse'}
                amount={'10vh'}
                offset={height * -0.3}
                duration={height * 1.1}
                stopProgressAt={0.55}
                disabled={isMobile || limitedPerformance > 0}
              >
                <div className={'willChangeTransform'}>
                  <View style={styles.secondTabletWrapper}>
                    <Image
                      loading={'eager'}
                      src={Assets.Portfolio.AWSGirlsTechSeries['background-tablet-2']}
                      style={styles.image}
                    />
                  </View>
                </div>
              </Reveal>
            ) : null}
          </View>
        )}
      </View>
    </CardComponents.AppRow>
  )
}

const styles = {
  wrapper: {
    [Theme.media.up('mid')]: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  },
  imagesWrapper: {
    [Theme.media.up('large')]: {
      display: 'flex',
      minWidth: '50%',
      justifyContent: 'flex-end',
    },
  },
  tabletWrapper: {
    [Theme.media.up('large')]: {
      zIndex: 9999,
    },
  },
  tabletInnerWrapper: {
    width: `calc(0.3 * ${Theme.values.portfolioCard.width})`,
    height: `calc(0.65 * ${Theme.values.portfolioCard.height})`,
    border: `10px solid ${Theme.colors.white}`,
    borderRadius: Theme.values.borderRadius.large,
    right: -160,
    backgroundColor: Theme.colors.white,
    [Theme.media.up('large')]: {
      position: 'absolute',
    },
    [Theme.media.down('large')]: {
      width: `calc(0.6 * ${Theme.values.portfolioCard.width})`,
    },
    [Theme.media.down('largeish')]: {
      height: `calc(0.6 * ${Theme.values.portfolioCard.height})`,
    },
  },
  secondTabletWrapper: {
    width: `calc(0.3 * ${Theme.values.portfolioCard.width})`,
    height: `calc(0.85 * ${Theme.values.portfolioCard.height})`,
    border: `10px solid ${Theme.colors.white}`,
    position: 'relative',
    borderRadius: Theme.values.borderRadius.large,
  },
  image: {
    width: '100%',
    height: '100%',
    borderRadius: Theme.values.borderRadius.medium,
    objectFit: 'fill',
  },
}

export default AWSGirlsTechSeriesCard
